import { Button, Collapse, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface Props {
  title: string;
  total: number;
  children: React.ReactNode;
  onAdd: () => void;
  addLabel?: string;
}

export const SectionWrapper = observer(({ title, total, children, onAdd, addLabel = "+ Eintrag hinzufügen" }: Props) => {
  return (
    <Collapse
      defaultActiveKey={["1"]}
      style={{ marginBottom: 16 }}
      items={[
        {
          key: "1",
          label: (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
              <Typography.Text strong style={{ fontSize: 16 }}>{title}</Typography.Text>
              <Typography.Text type="secondary">Summe: {total.toFixed(2)} €</Typography.Text>
            </div>
          ),
          children: (
            <>
              {children}
              <Button type="dashed" onClick={onAdd} style={{ marginTop: 8 }}>
                {addLabel}
              </Button>
            </>
          ),
        },
      ]}
    />
  );
});
